import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Actions, ofActionSuccessful, Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BaseComponent } from 'src/shared/abstracts/base.abstract';
import { ModalService } from './../../../shared/services/internal/modal.service';

import { Logout } from 'src/shared/store/actions/auth.action';
import { AuthState } from '../../../shared/store/state/auth.state';
import { MenuState } from '../../../shared/store/state/menu.state';

@Component({
    selector: 'app-headers',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseComponent implements OnInit {
    @Select(AuthState.isAuthenticated) public isAuth$: Observable<boolean>;
    @Select(MenuState.isOpen) public isMenuOpen$: Observable<boolean>;
    @Select(AuthState.dashboardSelected) public dashboardSelected$: Observable<boolean>;

    constructor(
        private actions$: Actions,
        private router: Router,
        private localize: LocalizeRouterService,
        private modalService: ModalService
    ) {
        super();
    }

    ngOnInit(): void {
        this.uns = this.actions$.pipe(ofActionSuccessful(Logout)).subscribe(() => {
            this.router.navigate([this.localize.translateRoute('/auth/login')]);
            this.modalService.closeModal();
        });
    }
}
